/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DnsSignatureValidationDto
 */
export interface DnsSignatureValidationDto {
    /**
     * DNS text with signature
     * @type {string}
     * @memberof DnsSignatureValidationDto
     */
    dnsText: string;
}

/**
 * Check if a given object implements the DnsSignatureValidationDto interface.
 */
export function instanceOfDnsSignatureValidationDto(value: object): boolean {
    if (!('dnsText' in value)) return false;
    return true;
}

export function DnsSignatureValidationDtoFromJSON(json: any): DnsSignatureValidationDto {
    return DnsSignatureValidationDtoFromJSONTyped(json, false);
}

export function DnsSignatureValidationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DnsSignatureValidationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'dnsText': json['dnsText'],
    };
}

export function DnsSignatureValidationDtoToJSON(value?: DnsSignatureValidationDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'dnsText': value['dnsText'],
    };
}

